var _g, _g2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirplaneEvent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.607962,0,0,0.305858,26.8196,13.4617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.896,5.578L17.802,5.578L18.345,15.654L20.408,15.654L20.896,5.578Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.527378,0,0,0.409898,25.1355,10.9988)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.112,
    cy: 21.019,
    rx: 1.783,
    ry: 1.911
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.912,14.182L7.705,21.313C7.523,21.623 7.52,22.006 7.698,22.318C7.876,22.629 8.207,22.822 8.566,22.822L21.587,22.822C21.946,22.822 22.277,22.629 22.455,22.318C22.633,22.006 22.63,21.623 22.448,21.313L15.938,10.278C15.758,9.973 15.43,9.786 15.076,9.786C14.723,9.786 14.395,9.973 14.215,10.278L13.826,10.938L13.18,8.383L13.182,8.38L12.73,6.45L16.62,2.56C17.2,1.97 17.2,1 16.62,0.438C16.04,-0.124 15.08,-0.148 14.5,0.438L10.61,4.33L1.41,2.21L0,3.62L7.43,7.5L3.54,11.4L1.06,11.05L0,12.11L3.18,13.87L4.95,17.06L6,16L5.66,13.5L9.55,9.63L9.911,10.323L9.91,10.324L11.912,14.182ZM15.076,12.754L19.836,20.822C19.836,20.822 10.317,20.822 10.317,20.822L15.076,12.754Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplaneEvent);
export default __webpack_public_path__ + "static/media/airplane-event.50c64a08.svg";
export { ForwardRef as ReactComponent };